module.exports = __webpack_public_path__ + "img/11825379_L.61b42d97.png";